import React, { useState, useEffect } from "react";
import "./PhoneNumberWrongCTA.css";

const PhoneNumberWrongCTA = ({ onClick, isFetching, loadingText = "Fetching more numbers..." }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible && !isFetching) return null;

  return (
    <div className={`phone-wrong-cta-container ${isFetching ? 'is-fetching' : ''}`}>
      {isFetching ? (
        <div className="fetching-container">
          <div className="spinner"></div>
          <span className="fetching-text">{loadingText}</span>
        </div>
      ) : (
        <span className="phone-wrong-cta-text">
          <span className="wrong-text">Wrong number?</span>
          <span className="view-others-text" onClick={onClick}> Load more</span>
        </span>
      )}
    </div>
  );
};

export default PhoneNumberWrongCTA;
